module.exports = __webpack_public_path__ + "static/media/PushtimargImage40.3fa5312f.jpg";